




























import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import {
  ProductMapping, ProductMappingResource,
} from '@/api/productmapping';

@Component({
  computed: mapState([
    'fiId',
  ]),
})
export default class ProductMappingSelect extends Vue {
  @Prop({ default: 'Select...' })
  label!: string;

  @Prop()
  value!: string[];

  @Prop()
  rules!: Array<any>;

  @Prop({ default: false })
  outlined!: boolean;

  @Prop({ default: false })
  dense!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  selectedProductMappings: string[] = [];

  loading: boolean = true;

  productMappings: ProductMapping[] = [];

  fiId!: string;

  @Inject('ProductMappingResource')
  productMappingResource!: ProductMappingResource;

  mounted() {
    this.loadData();
  }

  @Watch('fiId')
  loadData() {
    this.loading = true;
    this.loadProductMappings();
  }

  @Watch('value')
  onValueChange() {
    this.selectedProductMappings = [...this.value];
  }

  async loadProductMappings() {
    this.productMappings = [];
    await this.productMappingResource.get(this.fiId).then((returned: ProductMapping[]) => {
      this.productMappings = returned;
      this.onValueChange();
    }).catch((error: any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading = false;
    });
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  onNewSelection() {
    this.$emit('input', this.selectedProductMappings);
  }
}
